import React from 'react';
import type ProjectSettingsServiceDeskLanguageTranslationsType from '@atlassian/jira-spa-apps-project-settings-service-desk-language-translations/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskLanguageTranslations = lazyForPaint<
	typeof ProjectSettingsServiceDeskLanguageTranslationsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-language-translations", jiraSpaEntry: "async-project-settings-service-desk-language-translations" */ '@atlassian/jira-spa-apps-project-settings-service-desk-language-translations'
		),
);

const AsyncProjectSettingsServiceDeskLanguageTranslations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskLanguageTranslations}
		pageId="project-settings-language-translations"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskLanguageTranslations;
